module.exports = __webpack_public_path__ + "static/image_your-pals-at-27bce8a3edc6aea65b52e49f806e8e0e.png";